export default "__VITE_ASSET__962a487c__"